import { render, staticRenderFns } from "./PRJ913M01.vue?vue&type=template&id=12a9c6d6&"
import script from "./PRJ913M01.vue?vue&type=script&lang=js&"
export * from "./PRJ913M01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports